import { useRoutes } from 'react-router-dom';
import { BASE_URL } from '@/config';
import MainLayout from '@/layouts/dashboard';
import PrivateRoute from '@/components/PrivateRoute';
import Login from '@/pages/Login';
import NotFound from '@/pages/NotFound';
import Home from '@/pages/Home';
import User from '@/pages/User';
import Tier from '@/pages/Tier';
import Chantier from '@/pages/Chantier';
import Citerne from '@/pages/Citerne';
import Engin from '@/pages/Engin';
import Profile from '@/pages/Profile';
import Movment from '@/pages/Movment';
import Jauge from '@/pages/Jauge';

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: <MainLayout />,
      children: [
        {
          path: BASE_URL,
          element: (
            <PrivateRoute>
              <Home />
            </PrivateRoute>
          ),
        },
        {
          path: `${BASE_URL}users`,
          element: (
            <PrivateRoute>
              <User />
            </PrivateRoute>
          ),
        },
        {
          path: `${BASE_URL}profile`,
          element: (
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          ),
        },
        {
          path: `${BASE_URL}chantiers`,
          element: (
            <PrivateRoute>
              <Chantier />
            </PrivateRoute>
          ),
        },
        {
          path: `${BASE_URL}tiers`,
          element: (
            <PrivateRoute>
              <Tier />
            </PrivateRoute>
          ),
        },
        {
          path: `${BASE_URL}citernes`,
          element: (
            <PrivateRoute>
              <Citerne />
            </PrivateRoute>
          ),
        },
        {
          path: `${BASE_URL}movements`,
          element: (
            <PrivateRoute>
              <Movment />
            </PrivateRoute>
          ),
        },
        {
          path: `${BASE_URL}jauges`,
          element: (
            <PrivateRoute>
              <Jauge />
            </PrivateRoute>
          ),
        },
        {
          path: `${BASE_URL}engins`,
          element: (
            <PrivateRoute>
              <Engin />
            </PrivateRoute>
          ),
        },
      ],
    },
    { path: `${BASE_URL}login`, element: <Login /> },
    { path: '*', element: <NotFound /> },
  ]);
}
